<section class="neighborhood">

  <div class="container">
    <h2 id="product-neighborhood-title" class="no-border">Bairro</h2>
    <h3>{{data.neighborhood.name}}</h3>
    <h4>Sobre o bairro</h4>
    <p>{{data.neighborhood.description}}</p>
  </div>

  <ul>
    <li *ngFor="let item of data.neighborhood.interest_points; let i = index;">
      <figure>
        <img [src]="item.previewImage" alt="item.name">
      </figure>
      <h4>{{item.name}} <span>{{item.distance}}</span></h4>
      <p>{{item.description}}</p>
      <p class="address">{{item.address.street_type}} {{item.address.street}}, {{item.address.number}}</p>
      <a id="neighborhood-item-{{i}}" target="_blank" [href]="item.url">Veja mais</a>
    </li>
  </ul>

</section>